var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-message"},[_c('div',{staticClass:"header-message__body"},[_vm._t("default")],2),(_vm.canBeClosed)?_c('span',{staticClass:"shape-cross",on:{"click":_vm.closeMessage}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }